import type { ReactNode } from 'react';
import { Tabs } from '@shigo-ui/ui';

import { DashboardDetailsPageSkeleton } from './DashboardDetailsPageSkeleton';

export function DashboardDetailsPageShell(props: {
  activeTab: string;
  loading: boolean;
  loadingLabel: string;
  showHeaderAction?: boolean;
  metadataItemCount?: number;
  tabCount?: number;
  header: ReactNode;
  metadata?: ReactNode;
  tabs: ReactNode;
  children: ReactNode;
}) {
  if (props.loading) {
    return (
      <DashboardDetailsPageSkeleton
        label={props.loadingLabel}
        showHeaderAction={props.showHeaderAction}
        metadataItemCount={props.metadataItemCount}
        tabCount={props.tabCount}
      />
    );
  }
  // overflow-x-clip, not hidden: hidden made <main> a second vertical scroll container.
  return (
    <main className="min-w-0 overflow-x-clip">
      <Tabs value={props.activeTab}>
        <div className="border-border bg-card/60 border-b">
          <section className="page-gutter mx-auto flex w-full max-w-[1920px] flex-col gap-4 pt-5">
            {props.header}
            {props.metadata}
            {props.tabs}
          </section>
        </div>
        <section className="page-gutter mx-auto w-full max-w-[1920px] min-w-0 py-6">
          {props.children}
        </section>
      </Tabs>
    </main>
  );
}
